define.alias("shared/components/shared/ui/report/settings", "preview-grid/components/shared/ui/report/settings");